var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { StyledConfirmModal } from './styled';
import { Text, Title } from '../../Typography';
import BgEllipse from './BgEllipse';
import React, { useMemo } from 'react';
import { colors } from '../../../theme/colors';
import ErrorCircleSvg from '../../../assets/img/errorCircle.svg';
import InfoCircleSvg from '../../../assets/img/infoCircle.svg';
import SuccessCircleSvg from '../../../assets/img/successCircle.svg';
import WhaleEmptySvg from '../../../assets/img/whaleEmpty.svg';
import WhaleFailSvg from '../../../assets/img/whaleFail.svg';
import WhaleProcessSvg from '../../../assets/img/whaleProcess.svg';
import WhaleSuccessSvg from '../../../assets/img/whaleSuccess.svg';
import ModalButton from './ModalButton';
var getModalWidthByType = function (type, size) {
    if (type === void 0) { type = 'info'; }
    if (size === void 0) { size = 'small'; }
    return size === 'small' ? (type === null || type === void 0 ? void 0 : type.startsWith('whale')) ? 420 : 400 : 600;
};
var ModalConfirm = function (_a) {
    var _b = _a.modalType, modalType = _b === void 0 ? 'info' : _b, title = _a.title, subTitle = _a.subTitle, text = _a.text, content = _a.content, loading = _a.loading, _c = _a.cancelText, cancelText = _c === void 0 ? 'Отмена' : _c, _d = _a.okText, okText = _d === void 0 ? 'OK' : _d, _e = _a.size, size = _e === void 0 ? 'small' : _e, close = _a.close, onlyOkButton = _a.onlyOkButton, props = __rest(_a, ["modalType", "title", "subTitle", "text", "content", "loading", "cancelText", "okText", "size", "close", "onlyOkButton"]);
    var okButtonProps = useMemo(function () {
        switch (modalType) {
            case 'error':
                return { loading: loading, type: 'primary', danger: true };
            default:
                return { loading: loading, type: 'primary' };
        }
    }, [loading, modalType]);
    var modalIconSrc = useMemo(function () {
        switch (modalType) {
            case 'info':
                return InfoCircleSvg;
            case 'success':
                return SuccessCircleSvg;
            case 'error':
                return ErrorCircleSvg;
            case 'whaleProcess':
                return WhaleProcessSvg;
            case 'whaleSuccess':
                return WhaleSuccessSvg;
            case 'whaleError':
                return WhaleFailSvg;
            case 'whaleEmpty':
                return WhaleEmptySvg;
        }
    }, [modalType]);
    var footer = useMemo(function () {
        var result = [];
        if (!props.footer && close) {
            if (!onlyOkButton) {
                result.push(React.createElement(ModalButton, { key: 'cancel', actionFn: props.onCancel, close: close, buttonProps: props.cancelButtonProps }, cancelText));
            }
            result.push(React.createElement(ModalButton, { key: 'ok', actionFn: props.onOk, close: close, buttonProps: props.okButtonProps || okButtonProps }, okText));
        }
        return result;
    }, [onlyOkButton, cancelText, props, close, okButtonProps, okText]);
    return (React.createElement(StyledConfirmModal, __assign({ "data-testid": "confirmModal-" + modalType + "-" + size, okButtonProps: okButtonProps, cancelText: cancelText, okText: okText }, props, (close && { onCancel: function () { return close({ triggerCancel: true }); } }), { closable: false, width: getModalWidthByType(modalType, size), modalType: modalType, size: size }, (!props.footer &&
        close && {
        footer: footer,
    })),
        React.createElement("div", { className: 'bgEllipse' },
            React.createElement(BgEllipse, { size: size, modalType: modalType })),
        React.createElement("img", { src: modalIconSrc, className: 'modalIcon' }),
        React.createElement("div", { className: 'text-container' },
            title && React.createElement(Title, { className: 'title' }, title),
            subTitle && (React.createElement(Text, { color: colors.primaryText, className: 'subTitle' }, subTitle)),
            content && React.createElement("div", { className: 'content' }, content),
            text && (React.createElement("div", { className: 'text' },
                React.createElement(Text, { color: colors.primaryText }, text))))));
};
export default ModalConfirm;
//# sourceMappingURL=ModalConfirm.js.map